import { render, h } from 'preact'
import { signal, computed } from '@preact/signals';
import * as d3 from 'd3';

import { AppState } from './appstate';
import { Taxon } from './ebird/taxonomy';
import { dayOfYearSpecies } from './ebird/agg';

import App from './ui/app';
import { Store, initStore } from '@/db';

// TODO: Make this an external file for esbuild
declare global { interface Window { taxonomy2023: Taxon[] } }

async function createAppState(store: Store): Promise<AppState> {
  // TODO: Figure out all my computed filters
  const all = await store.allObservations();

  // TODO: Double check that the counts are right
  const daily = dayOfYearSpecies(all);

  // TODO: Figure out a better way to plumb through the colors...
  // Compute a color scale. Any 0 days get "none" and don't impact the scale which I prefer
  // TODO: I want my extent to always have the minimum of 1
  const dayColor = computed(() => {
    const [, max] = d3.extent(daily.values(), d => d.size) as [number, number];
    const scheme = d3.schemeOrRd[3] as string[];
    const interp = d3.interpolateRgbBasis(scheme);
    return d3.scaleSequential([1, max], interp).unknown("");
  });

  return {
    store,
    allObservations: all,
    timeframe: signal('All'), // combine w/ region into a "scope"
    region: signal('All'),
    theme: { dayColor },
    url: new URL(window.location.href),
  };
}

initStore(window.taxonomy2023).then(async store => {
  const appState = await createAppState(store);

  // TODO: Could technically import a file with 0 observations
  if (!appState.url.pathname.startsWith("/import") &&
      appState.allObservations.length === 0) {
    window.location.href = '/import';
  } else {
    const host = document.getElementById('preact-app')!;
    render(h(App, appState), host);
  }
});
